import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as i18next from 'i18next';
import LocizeBackend from 'i18next-locize-backend';
import { initReactI18next } from 'react-i18next';
export var REFERENCE_LANG = 'en';

var initOptions = function initOptions(_ref) {
  var projectId = _ref.projectId,
      apiKey = _ref.apiKey,
      _ref$options = _ref.options,
      _ref$options$lang = _ref$options.lang,
      lang = _ref$options$lang === void 0 ? REFERENCE_LANG : _ref$options$lang,
      _ref$options$fallback = _ref$options.fallbackLang,
      fallbackLang = _ref$options$fallback === void 0 ? REFERENCE_LANG : _ref$options$fallback,
      _ref$options$ns = _ref$options.ns,
      ns = _ref$options$ns === void 0 ? ['translations'] : _ref$options$ns,
      _ref$options$defaultN = _ref$options.defaultNS,
      defaultNS = _ref$options$defaultN === void 0 ? 'translations' : _ref$options$defaultN,
      _ref$options$version = _ref$options.version,
      version = _ref$options$version === void 0 ? 'stable' : _ref$options$version;
  return {
    lng: lang.replace(/_/g, '-'),
    fallbackLng: fallbackLang,
    appendNamespaceToCIMode: true,
    // provides more info in the dev console, recommended by i18next-locize-backend
    debug: false,
    // Using the feature to add new keys during development is meant to be only used during development.
    // Using it in production can lead to spamming Locize endpoint with unneeded requests.
    // Doing so can force us to start charging you for those saveMissing calls (which currently are free)
    // or in worst case we will be forced to suspend your account.
    // More on https://docs.locize.com/guides-tips-and-tricks/going-production
    saveMissing: !!apiKey,
    // have a common namespace used around the full app
    ns: ns,
    defaultNS: defaultNS,
    load: 'currentOnly',
    backend: _objectSpread({
      projectId: projectId,
      referenceLng: REFERENCE_LANG,
      version: version
    }, apiKey ? {
      apiKey: apiKey,
      allowedAddOrUpdateHosts: ['app.infldev.com', 'advocate-app.infldev.com']
    } : {}),
    react: {
      useSuspense: false,
      bindI18nStore: false
    },
    initImmediate: false
  };
};

export var i18nLocizeInstance = function i18nLocizeInstance(props) {
  var instance = i18next.createInstance();
  void instance.use(LocizeBackend).use(initReactI18next).init(initOptions(props));
  return instance;
};